import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { apiRequest } from "../services/apiService";
const LineChart = ({ clientId, acquirerId, currency }) => {
  const role = sessionStorage.getItem("role");
  const [approvalRatios, setApprovalRatios] = useState([]);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (role === "client") return;
    const fetchTransactionData = async () => {
      try {
        setLoading(true);
        const url = `api/v1/stats/dashboard/weekly-approval-ratio?clientId=${clientId}&acquirerId=${acquirerId}&currency=${currency}`;
        const response = await apiRequest(url, "GET");
      
        const transactions = response?.data || [];
        const tempData = {};
        for (let i = 0; i < 7; i++) {
          const day = new Date();
          day.setUTCDate(day.getUTCDate() - 6 + i);
          const dateString = day.toISOString().split("T")[0];
          tempData[dateString] = 0;
        }
        transactions.forEach(({ date, approval_ratio_percent }) => {
          tempData[date] = approval_ratio_percent || 0;
        });
        setLabels(
          Object.keys(tempData).map((date) => {
            const d = new Date(date);
            const day = String(d.getUTCDate()).padStart(2, "0");
            const month = String(d.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
            return `${day}/${month}`;
          })
        );
        setApprovalRatios(Object.values(tempData));
      } catch (error) {
        console.error("Error fetching approval ratio data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTransactionData();
  }, [role, clientId, acquirerId, currency]);
  const trace1 = {
    x: labels,
    y: approvalRatios,
    type: "scatter",
    mode: "lines+markers",
    marker: { color: "blue" },
    line: { shape: "spline" },
    name: "Approval Ratio",
    hovertemplate: "%{y}<extra></extra>",
  };

  const data = [trace1];
  const layout = {
    height: 250,
    margin: { l: 60, r: 30, t: 30, b: 30 },
    yaxis: {
      range: [0, 100],
      title: "Approval Ratio (%)",
      tickmode: "linear",
      dtick: 10,
    },
  };
  return (
    <div
      style={{
        width: "100%",
        borderRadius: "15px",
        overflow: "hidden",
      }}
    >
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Plot
          data={data}
          layout={layout}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  );
};
export default LineChart;
